<template>
  <a-modal
    title="生成兑换码"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
    width="750px"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :okText="step == 0 ? '生成' : '完成'"
    class="generate-code-modal"
  >
    <a-form-model
      v-if="step == 0"
      ref="ruleForm"
      :model="form"
      :rules="rules"
      labelAlign="left"
      layout="horizontal"
      :colon="true"
      style="height: 500px; margin-left: 180px; margin-top: 30px"
    >
      <!-- :label-col="labelCol"
      :wrapper-col="wrapperCol" -->
      <a-form-model-item label="有效期" prop="period">
        <a-input-number
          v-model="form.period"
          :min="0"
          style="width: 300px"
          placeholder="请输入有效期"
        /><span style="margin-left: 10px">天</span>
      </a-form-model-item>
      <a-form-model-item label="生成兑换码数量" prop="codeNum">
        <a-input-number
          v-model="form.codeNum"
          :min="0"
          :max="10"
          style="width: 300px"
          placeholder="请输入生成兑换码数量"
        /><span style="margin-left: 10px">最多10个</span>
      </a-form-model-item>
    </a-form-model>
    <div v-else style="height: 500px">
      <div style="font-weight: bold; color: #333333"><span>兑换码</span></div>
      <div style="font-size: 12px; color: #999999">
        <span>用户可通过兑换码添加并使用兑换资源</span>
      </div>
      <div style="margin-top: 20px">
        <div class="code-single code-container" v-if="codes.length === 1">
          <span>{{ codes[0] }}</span>
          <a-icon type="copy" class="copy" @click="mixin_copy(codes[0])" />
        </div>
        <div class="code-multi" :class="{ wrap: codes.length > 5 }" v-else>
          <div
            class="code-row code-container"
            v-for="(item, index) in codes"
            :key="item"
          >
            <div class="index">{{ index + 1 }}</div>
            <div class="code-item">
              <span>{{ item }}</span>
              <a-icon type="copy" class="copy" @click="mixin_copy(item)" />
            </div>
          </div>
        </div>
        <div
          class="allCenter"
          @click="mixin_copy(codes.join('\n'))"
          v-if="codes.length > 1"
        >
          <a-button type="link">全部复制</a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import copyMixin from '@/utils/mixin/copy.js'
import { generateRedemptionCode } from '@/utils/util.js'
export default {
  name: 'generateCodeModal',
  mixins: [copyMixin],
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      step: 0,
      form: {
        period: '',
        codeNum: undefined,
      },
      confirmLoading: false,
      rules: {
        period: [
          {
            required: true,
            message: '请输入有效期',
            trigger: 'blur',
          },
        ],
        codeNum: [
          {
            required: true,
            message: '请输入生成兑换码数量',
            trigger: 'blur',
          },
        ],
      },
      codes: [],
    }
  },
  methods: {
    handleOk() {
      if (this.step == 0) {
        this.confirmLoading = true
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const { codeNum, period } = this.form
            let codes = []
            for (let i = 0; i < codeNum; i++) {
              const getLicenseCode = generateRedemptionCode(16) // 16位兑换码
              const code = getLicenseCode()
              codes.push(code)
            }
            console.log('success', valid, codeNum, period, codes)

            this.$api
              .generateCode({
                vipCardId: this.$route.query.id,
                day: period,
                code: codes.join(','),
              })
              .then((res) => {
                if (res.code == 0) {
                  this.codes = codes
                  this.confirmLoading = false
                  this.$message.success('生成成功')
                  this.step = 1
                }
              }).catch(() => {
                this.confirmLoading = false
                this.$message.error('生成失败')
              })
          }
        })
      } else {
        this.$emit('update:visible', false)
        this.$emit('refresh')
      }
    },
    handleCancel() {
      this.$emit('update:visible', false)
      if (this.step == 1) this.$emit('refresh')
    }
  },
}
</script>

<style lang="less" scoped>
.generate-code-modal {
  .copy {
    cursor: pointer;
    font-size: 17px;
    color: #0059ff;
  }
  .code-container {
    border-radius: 4px;
    background-color: #f2f2f2;
    display: flex;
    align-items: center;
  }
  .code-single {
    position: relative;
    justify-content: center;
    height: 50px;
    font-size: 18px;
    font-weight: bold;
    .copy {
      position: absolute;
      top: 8px;
      right: 0;
      padding: 9px;
    }
  }
  .code-multi {
    overflow-y: auto;
    max-height: calc(100vh - 506px);
    padding-right: 6px;
    &.wrap {
      display: flex;
      flex-wrap: wrap;
      .code-row {
        width: calc(50% - 4px);
        &:nth-of-type(2n-1) {
          margin-right: 8px;
        }
      }
    }
    .code-row {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      height: 36px;
      .index {
        width: 30px;
        text-align: center;
        font-size: 12px;
        color: #bbbcbf;
      }
      .code-item {
        position: relative;
        font-weight: bold;
        flex: 1;
        justify-content: space-between;
        padding-right: 6px;
        .copy {
          position: absolute;
          top: -6px;
          right: 0;
          padding: 9px;
        }
      }
    }
  }
  .allCenter {
    text-align: right;
  }
}
</style>